import type { Selection } from "../charts/utils";
import enovaActivityDataRaw from "../data/enova-activity-data.json";

export type EnovaActivityPoint = {
    year: number;
    count: number;
    amount: number;
};

type EnovaActivityStore = Record<string, Record<string, Record<string, EnovaActivityPoint[]>>>;

const enovaActivityData = enovaActivityDataRaw as EnovaActivityStore;

export const hasEnovaActivityDataForSelection = (selection: Selection): boolean => {
    return Boolean(getEnovaActivityDataForSelection(selection));
};

export const getEnovaActivityDataForSelection = (selection: Selection): EnovaActivityPoint[] | null => {
    if (!selection.level1 || !selection.level2 || !selection.level3) {
        return null;
    }

    const systemStore = enovaActivityData[selection.level1];
    if (!systemStore) {
        return null;
    }

    const level1Store = systemStore[selection.level2];
    if (!level1Store) {
        return null;
    }

    const level3Data = level1Store[selection.level3];
    if (!level3Data || level3Data.length === 0) {
        return null;
    }

    return level3Data;
};
